export default function LandParcelAnalysis() {
  const parcels = [
    {
      number: '1302',
      area: '766.9',
      landUse: '주유소',
      ownership: '이종훈 (단독)',
      publicPrice: '25,070,000',
      risk: '대로변 진입 거점',
      note: '토양 오염 정화 필요',
      priority: 'high'
    },
    {
      number: '1302-1',
      area: '2,291.4',
      landUse: '대',
      ownership: '집합건물 (다수)',
      publicPrice: '23,350,000',
      risk: '사업지 핵심 면적',
      note: '대지권 해체 난제',
      priority: 'critical'
    },
    {
      number: '1302-2',
      area: '1,689.9',
      landUse: '대',
      ownership: '공유 (송창래 외)',
      publicPrice: '20,880,000',
      risk: '중앙 위치',
      note: '지분권자 협의 필수',
      priority: 'high'
    },
    {
      number: '1302-3',
      area: '30.4',
      landUse: '대',
      ownership: '윤정엽 (단독)',
      publicPrice: '20,880,000',
      risk: '1302-2 연계 필지',
      note: '통합 협상 가능',
      priority: 'medium'
    },
    {
      number: '1302-12',
      area: '320.9',
      landUse: '대',
      ownership: '집합건물 (다수)',
      publicPrice: '8,892,000',
      risk: '현황 도로 추정',
      note: '공공보행통로 활용',
      priority: 'medium'
    },
    {
      number: '1302-13',
      area: '308.2',
      landUse: '대',
      ownership: '공유 (송창래 외)',
      publicPrice: '21,230,000',
      risk: '1302-2 연계 필지',
      note: '통합 협상 가능',
      priority: 'medium'
    },
    {
      number: '1302-18',
      area: '8.4',
      landUse: '대',
      ownership: '집합건물 (다수)',
      publicPrice: '23,350,000',
      risk: '자투리 땅',
      note: '알박기 가능성',
      priority: 'high'
    },
    {
      number: '1302-19',
      area: '4.1',
      landUse: '대',
      ownership: '집합건물 (다수)',
      publicPrice: '23,350,000',
      risk: '자투리 땅',
      note: '최우선 확보 대상',
      priority: 'critical'
    }
  ];

  const strategies = [
    {
      title: '상업 거점 클러스터',
      parcels: '1302번지',
      icon: 'ri-gas-station-line',
      description: '주유소 용지로 프로젝트 전면부 랜드마크 이미지를 결정짓는 핵심 부지',
      strategy: [
        'SPC 발행 후순위 채권 또는 준공 후 상업시설 우선 분양권 제안',
        '양도소득세 부담 이연 전략 구사',
        '토양 오염 정밀 조사 및 정화 비용 산출',
        '매매 대금 공제 또는 매도인 정화 책임 특약 설계'
      ],
      color: 'bg-red-50 border-red-200'
    },
    {
      title: '중앙부 투자자 클러스터',
      parcels: '1302-2, 1302-3, 1302-13',
      icon: 'ri-building-4-line',
      description: '자산가들이 통제하는 중앙부 핵심 필지로 사업지 허리 부분 차지',
      strategy: [
        'SPC 주주 참여를 통한 개발 이익 공유 제안',
        '지주 공동 개발 형태의 협상 구조 설계',
        '롯데칠성 부지 개발 연계 적기 매도 명분 제시',
        '필지 분절 개발 리스크 방지를 위한 우선 협상'
      ],
      color: 'bg-amber-50 border-amber-200'
    },
    {
      title: '집합건물 클러스터',
      parcels: '1302-1, 1302-12, 1302-18, 1302-19',
      icon: 'ri-community-line',
      description: '다수의 구분소유자가 존재하는 최고 난이도 협상 대상',
      strategy: [
        '집합건물법에 따른 재건축 결의 추진',
        '주택법 사업계획 승인 후 매도청구권 행사',
        '1302-12 사도를 공공기여 시설로 전환하여 용적률 인센티브 확보',
        '노후 건물 재건축 수요 활용한 단계적 협상'
      ],
      color: 'bg-teal-50 border-teal-200'
    }
  ];

  const getPriorityBadge = (priority: string) => {
    switch (priority) {
      case 'critical':
        return 'bg-red-100 text-red-700 border border-red-300';
      case 'high':
        return 'bg-orange-100 text-orange-700 border border-orange-300';
      case 'medium':
        return 'bg-blue-100 text-blue-700 border border-blue-300';
      default:
        return 'bg-gray-100 text-gray-700 border border-gray-300';
    }
  };

  const getPriorityText = (priority: string) => {
    switch (priority) {
      case 'critical':
        return '최우선';
      case 'high':
        return '높음';
      case 'medium':
        return '중간';
      default:
        return '일반';
    }
  };

  return (
    <section id="land-analysis" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">필지별 권리관계 분석</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            8개 필지의 물리적 합필과 법적 소유권 단일화를 위한<br />
            체계적인 매입 전략 및 리스크 관리 방안
          </p>
        </div>

        {/* 필지별 상세 현황 테이블 */}
        <div className="mb-20">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-3">
              <i className="ri-file-list-3-line text-teal-600 text-xl"></i>
            </div>
            대상 사업지 필지별 현황 및 평가
          </h3>
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-900 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold whitespace-nowrap">지번</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold whitespace-nowrap">면적 (㎡)</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold whitespace-nowrap">지목</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold whitespace-nowrap">소유 구조</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold whitespace-nowrap">2024 공시지가 (원/㎡)</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold whitespace-nowrap">주요 리스크</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold whitespace-nowrap">우선순위</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {parcels.map((parcel, index) => (
                    <tr key={index} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 text-sm font-semibold text-gray-900 whitespace-nowrap">{parcel.number}</td>
                      <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap">{parcel.area}</td>
                      <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap">{parcel.landUse}</td>
                      <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap">{parcel.ownership}</td>
                      <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap">{Number(parcel.publicPrice).toLocaleString()}</td>
                      <td className="px-6 py-4 text-sm text-gray-700">
                        <div className="font-medium text-gray-900">{parcel.risk}</div>
                        <div className="text-xs text-gray-500 mt-1">{parcel.note}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${getPriorityBadge(parcel.priority)}`}>
                          {getPriorityText(parcel.priority)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-500 text-center">
            * 2024년 공시지가 및 토지대장 데이터 기준
          </div>
        </div>

        {/* 클러스터별 매입 전략 */}
        <div className="mb-20">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-3">
              <i className="ri-lightbulb-line text-teal-600 text-xl"></i>
            </div>
            클러스터별 매입 및 명도 전략
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            {strategies.map((strategy, index) => (
              <div key={index} className={`${strategy.color} rounded-2xl p-8 border-2`}>
                <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm">
                  <i className={`${strategy.icon} text-3xl text-gray-900`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">{strategy.title}</h4>
                <div className="text-sm font-semibold text-gray-700 mb-4">{strategy.parcels}</div>
                <p className="text-sm text-gray-700 mb-6 leading-relaxed">{strategy.description}</p>
                <div className="space-y-3">
                  {strategy.strategy.map((item, idx) => (
                    <div key={idx} className="flex items-start">
                      <div className="w-5 h-5 bg-white rounded flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-teal-600 text-sm"></i>
                      </div>
                      <p className="text-sm text-gray-700 leading-relaxed">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 통합 리스크 관리 방안 */}
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-10 text-white">
          <h3 className="text-2xl font-bold mb-6 flex items-center">
            <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center mr-3">
              <i className="ri-shield-check-line text-white text-xl"></i>
            </div>
            소유권 통합 리스크 관리
          </h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="text-lg font-bold mb-4 text-teal-400">법적 리스크 대응</h4>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-400 text-xl mr-2 flex-shrink-0"></i>
                  <span className="text-sm leading-relaxed">집합건물법 재건축 결의 및 매도청구권 행사 절차 준비</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-400 text-xl mr-2 flex-shrink-0"></i>
                  <span className="text-sm leading-relaxed">토양 오염 정화 책임 및 비용 분담 특약 설계</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-400 text-xl mr-2 flex-shrink-0"></i>
                  <span className="text-sm leading-relaxed">공유지분 협의 및 지분권자 동의 확보 프로세스</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-400 text-xl mr-2 flex-shrink-0"></i>
                  <span className="text-sm leading-relaxed">자투리 필지 알박기 방지를 위한 선제적 매입</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4 text-teal-400">재무 리스크 대응</h4>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-400 text-xl mr-2 flex-shrink-0"></i>
                  <span className="text-sm leading-relaxed">SPC 후순위 채권 발행을 통한 양도세 이연 구조</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-400 text-xl mr-2 flex-shrink-0"></i>
                  <span className="text-sm leading-relaxed">지주 공동 개발 방식의 개발 이익 공유 모델</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-400 text-xl mr-2 flex-shrink-0"></i>
                  <span className="text-sm leading-relaxed">준공 후 상업시설 우선 분양권 제공 방안</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-400 text-xl mr-2 flex-shrink-0"></i>
                  <span className="text-sm leading-relaxed">단계적 매입을 통한 자금 집행 리스크 분산</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}